import { type SideNavSection } from '@dittolive/anvil'
import { GearIcon, UsersIcon } from '@phosphor-icons/react'
import paths from 'paths'
import { useMemo } from 'react'

/** Sidebar navigation for an employee group's management pages. */
export function useEmployeeGroupNavSections(slug: string): SideNavSection[] {
  return useMemo(
    () => [
      {
        items: [
          {
            text: 'Customers',
            to: paths.employeeGroupManagement({ slug, area: 'customers' }),
            icon: <UsersIcon />,
          },
          {
            text: 'Employees',
            to: paths.employeeGroupManagement({ slug, area: 'employees' }),
            icon: <UsersIcon />,
          },
          {
            text: 'Settings',
            to: paths.employeeGroupManagement({ slug, area: 'settings' }),
            icon: <GearIcon />,
          },
        ],
      },
    ],
    [slug],
  )
}
